import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07b6ba86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=07b6ba86&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6ba86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b6ba86')) {
      api.createRecord('07b6ba86', component.options)
    } else {
      api.reload('07b6ba86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07b6ba86&scoped=true", function () {
      api.rerender('07b6ba86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settlement/index.vue"
export default component.exports